/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function ContactsIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-contact">
        <g id="Group 61 Copy 2">
          <g id="Group 59 Copy 3">
            <g id="icon-legal and finance copy">
              <g id="Group 58 Copy 2">
                <g id="icon-journey-course">
                  <circle
                    id="Oval"
                    cx="78.5"
                    cy="78.5"
                    r="77.5"
                    fill={mainColor}
                    stroke="white"
                    stroke-width="2"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="phone-book copy">
          <path
            id="Shape"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M114 112.601V43.4012C114 41.52 112.473 40 110.59 40H52.6592C50.7697 40 49.243 41.5221 49.243 43.4012V46.365H52.3981C55.3286 46.365 57.7136 48.8567 57.7136 51.9242C57.7136 54.9918 55.3286 57.4881 52.3981 57.4881H49.243V63.7452H52.3981C55.3286 63.7452 57.7136 66.2415 57.7136 69.3091C57.7136 72.3766 55.3286 74.873 52.3981 74.873H49.243V81.1296H52.3981C55.3286 81.1296 57.7136 83.6213 57.7136 86.6888C57.7136 89.7564 55.3286 92.2527 52.3981 92.2527H49.243V98.5119H52.3981C55.3286 98.5119 57.7136 101.008 57.7136 104.073C57.7136 107.141 55.3286 109.637 52.3981 109.637H49.243V112.601C49.243 114.48 50.7718 116 52.6592 116H110.588C112.473 116 114 114.475 114 112.601ZM55.3703 51.9242C55.3703 53.6445 54.0426 55.0379 52.4028 55.0379H45.9722C44.3277 55.0358 43 53.6471 43 51.9242C43 50.2061 44.3277 48.8131 45.9722 48.8131H52.4002C54.0405 48.8131 55.3703 50.2065 55.3703 51.9242ZM55.3703 69.3091C55.3703 67.5909 54.0426 66.1933 52.4028 66.1933H45.9722C44.3277 66.1933 43 67.5867 43 69.3091C43 71.0272 44.3277 72.4228 45.9722 72.4228H52.4002C54.0405 72.4181 55.3703 71.0272 55.3703 69.3091ZM52.4028 83.573C54.0426 83.573 55.3703 84.9685 55.3703 86.6867C55.3703 88.4095 54.0405 89.8025 52.4002 89.8025H45.9722C44.3277 89.8025 43 88.4049 43 86.6867C43 84.9639 44.3277 83.5751 45.9722 83.573H52.4028ZM55.3703 104.067C55.3703 102.351 54.0426 100.958 52.4028 100.958H45.9722C44.3277 100.96 43 102.349 43 104.067C43 105.789 44.3277 107.183 45.9722 107.183H52.4002C54.0405 107.183 55.3703 105.789 55.3703 104.067ZM75.2883 68.8645C75.3691 67.856 76.0168 66.7665 76.8474 66.8796C77.4877 66.9696 78.7737 67.794 79.7876 68.444L79.7877 68.444C80.2531 68.7424 80.6612 69.004 80.9232 69.141C83.1899 70.2994 86.8426 61.3225 85.147 60.2657C84.6686 59.9711 84.2083 59.6382 83.7474 59.3051L83.7473 59.305C82.9291 58.7135 82.1094 58.1208 81.1847 57.7392C81.0277 57.6751 80.8599 57.6525 80.6902 57.6296C80.5976 57.6171 80.5044 57.6045 80.412 57.5851C74.502 56.2679 68.4721 61.3457 67.8567 68.9869C67.616 71.9071 67.4821 74.8315 67.4242 77.7584H67.4102L67.4108 77.7695C67.4153 77.8459 67.4195 77.9189 67.4195 77.9981C67.4195 78.0679 67.4162 78.1279 67.4124 78.1973L67.4102 78.2377H67.4242C67.4753 81.1647 67.6139 84.0896 67.8567 87.0093C68.4721 94.6458 74.502 99.7236 80.412 98.4064C80.4998 98.3894 80.5883 98.3778 80.6764 98.3663C80.8508 98.3435 81.0234 98.321 81.1847 98.2565C82.1143 97.8729 82.9378 97.277 83.7604 96.6819C84.2169 96.3516 84.6731 96.0215 85.147 95.728C86.84 94.6733 83.1903 85.701 80.9232 86.8527C80.6626 86.9892 80.2565 87.2505 79.793 87.5487L79.7928 87.5488L79.7926 87.5489C78.7788 88.2011 77.4902 89.0301 76.8474 89.1187C76.0215 89.2318 75.3691 88.1377 75.2883 87.1313C75.1344 85.2458 75.187 82.9875 75.2373 80.8274C75.258 79.9372 75.2783 79.0637 75.2837 78.2399H75.2883V78.0002V77.7606H75.2837C75.2782 76.9373 75.2579 76.0653 75.2373 75.1769V75.1769V75.1769V75.1768C75.1869 73.0135 75.1343 70.7533 75.2883 68.8645ZM89.9925 70.343C94.2346 74.5664 94.2346 81.4293 89.9925 85.6528L87.7373 83.4049C90.7372 80.4276 90.7372 75.5754 87.7373 72.593L89.9925 70.343ZM94.0194 89.653C100.471 83.2301 100.471 72.7729 94.0148 66.3453L91.7596 68.5906C96.9734 73.7814 96.9734 82.2236 91.7596 87.412L94.0194 89.653ZM95.6572 64.7126L97.9124 62.4695C106.51 71.0315 106.51 84.9643 97.9124 93.531L95.6572 91.2857C103.013 83.9604 103.013 72.0383 95.6572 64.7126Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

ContactsIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
ContactsIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(ContactsIcon);
memoized.displayName = 'ContactsIcon';
export default memoized;
